module.exports = __webpack_public_path__ + "img/hatakaku@2x.93d9598.png";